export const statistic_promo_2_data = [
	
	{
		id: '1',
		img: '/images/pelgine_chars.png',
	},
];
